export const defaults: {[index: string]: string} = {
  time: 'time',
  dataview: 'default_view',
  palette: 'vik',
  background_highlight: '#adadad',
  border: '#7e7e7e',
  border_highlight_true: '#ffffff',
  border_highlight_false: '#000000',
  missing: '#00000000',
}
